import React, { createContext, useContext } from 'react';
import { useDevice } from './useDevice';

const DeviceContext = createContext(null);

export function DeviceProvider({ children }) {
  const device = useDevice();

  return (
    <DeviceContext.Provider value={device}>
      {children}
    </DeviceContext.Provider>
  );
}

export function useDeviceContext() {
  const ctx = useContext(DeviceContext);
  if (!ctx) {
    throw new Error('useDeviceContext must be used within a DeviceProvider');
  }
  return ctx;
}
